/**
 * @fileoverview gRPC-Web generated client stub for social.post
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: services/post/post.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var services_common_common_pb = require('../../services/common/common_pb.js')

var services_account_account_pb = require('../../services/account/account_pb.js')

var services_discussion_discussion_pb = require('../../services/discussion/discussion_pb.js')
const proto = {};
proto.social = {};
proto.social.post = require('./post_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.social.post.PostServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.social.post.PostServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Pong>}
 */
const methodDescriptor_PostService_Ping = new grpc.web.MethodDescriptor(
  '/social.post.PostService/Ping',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Pong,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Pong.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Pong)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Pong>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/Ping',
      request,
      metadata || {},
      methodDescriptor_PostService_Ping,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Pong>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/Ping',
      request,
      metadata || {},
      methodDescriptor_PostService_Ping);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.UploadMediaRequest,
 *   !proto.social.common.UploadMediaResponse>}
 */
const methodDescriptor_PostService_UploadPostMedia = new grpc.web.MethodDescriptor(
  '/social.post.PostService/UploadPostMedia',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.UploadMediaRequest,
  services_common_common_pb.UploadMediaResponse,
  /**
   * @param {!proto.social.common.UploadMediaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.UploadMediaResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.UploadMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.UploadMediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.UploadMediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.uploadPostMedia =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/UploadPostMedia',
      request,
      metadata || {},
      methodDescriptor_PostService_UploadPostMedia,
      callback);
};


/**
 * @param {!proto.social.common.UploadMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.UploadMediaResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.uploadPostMedia =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/UploadPostMedia',
      request,
      metadata || {},
      methodDescriptor_PostService_UploadPostMedia);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.Post,
 *   !proto.social.post.Post>}
 */
const methodDescriptor_PostService_PublishPost = new grpc.web.MethodDescriptor(
  '/social.post.PostService/PublishPost',
  grpc.web.MethodType.UNARY,
  proto.social.post.Post,
  proto.social.post.Post,
  /**
   * @param {!proto.social.post.Post} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.Post.deserializeBinary
);


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.Post)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.Post>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.publishPost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/PublishPost',
      request,
      metadata || {},
      methodDescriptor_PostService_PublishPost,
      callback);
};


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.Post>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.publishPost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/PublishPost',
      request,
      metadata || {},
      methodDescriptor_PostService_PublishPost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.Post,
 *   !proto.social.post.Post>}
 */
const methodDescriptor_PostService_UpdatePost = new grpc.web.MethodDescriptor(
  '/social.post.PostService/UpdatePost',
  grpc.web.MethodType.UNARY,
  proto.social.post.Post,
  proto.social.post.Post,
  /**
   * @param {!proto.social.post.Post} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.Post.deserializeBinary
);


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.Post)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.Post>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.updatePost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/UpdatePost',
      request,
      metadata || {},
      methodDescriptor_PostService_UpdatePost,
      callback);
};


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.Post>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.updatePost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/UpdatePost',
      request,
      metadata || {},
      methodDescriptor_PostService_UpdatePost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.Post,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_DeletePost = new grpc.web.MethodDescriptor(
  '/social.post.PostService/DeletePost',
  grpc.web.MethodType.UNARY,
  proto.social.post.Post,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.Post} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.deletePost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/DeletePost',
      request,
      metadata || {},
      methodDescriptor_PostService_DeletePost,
      callback);
};


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.deletePost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/DeletePost',
      request,
      metadata || {},
      methodDescriptor_PostService_DeletePost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.Post,
 *   !proto.social.post.Post>}
 */
const methodDescriptor_PostService_GetPost = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetPost',
  grpc.web.MethodType.UNARY,
  proto.social.post.Post,
  proto.social.post.Post,
  /**
   * @param {!proto.social.post.Post} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.Post.deserializeBinary
);


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.Post)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.Post>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getPost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetPost',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPost,
      callback);
};


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.Post>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getPost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetPost',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.discussion.Discussion,
 *   !proto.social.post.Post>}
 */
const methodDescriptor_PostService_GetPostByDiscussionID = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetPostByDiscussionID',
  grpc.web.MethodType.UNARY,
  services_discussion_discussion_pb.Discussion,
  proto.social.post.Post,
  /**
   * @param {!proto.social.discussion.Discussion} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.Post.deserializeBinary
);


/**
 * @param {!proto.social.discussion.Discussion} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.Post)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.Post>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getPostByDiscussionID =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetPostByDiscussionID',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPostByDiscussionID,
      callback);
};


/**
 * @param {!proto.social.discussion.Discussion} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.Post>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getPostByDiscussionID =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetPostByDiscussionID',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPostByDiscussionID);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.GetPostsRequest,
 *   !proto.social.post.PostListResponse>}
 */
const methodDescriptor_PostService_GetPosts = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetPosts',
  grpc.web.MethodType.UNARY,
  proto.social.post.GetPostsRequest,
  proto.social.post.PostListResponse,
  /**
   * @param {!proto.social.post.GetPostsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.PostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.post.GetPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.PostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.PostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getPosts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPosts,
      callback);
};


/**
 * @param {!proto.social.post.GetPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.PostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getPosts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPosts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.GetPostsRequest,
 *   !proto.social.post.PostListResponse>}
 */
const methodDescriptor_PostService_GetFeed = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetFeed',
  grpc.web.MethodType.UNARY,
  proto.social.post.GetPostsRequest,
  proto.social.post.PostListResponse,
  /**
   * @param {!proto.social.post.GetPostsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.PostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.post.GetPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.PostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.PostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getFeed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetFeed',
      request,
      metadata || {},
      methodDescriptor_PostService_GetFeed,
      callback);
};


/**
 * @param {!proto.social.post.GetPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.PostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getFeed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetFeed',
      request,
      metadata || {},
      methodDescriptor_PostService_GetFeed);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.post.PostListResponse>}
 */
const methodDescriptor_PostService_Find = new grpc.web.MethodDescriptor(
  '/social.post.PostService/Find',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.post.PostListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.PostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.PostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.PostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.find =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/Find',
      request,
      metadata || {},
      methodDescriptor_PostService_Find,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.PostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.find =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/Find',
      request,
      metadata || {},
      methodDescriptor_PostService_Find);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.GetSavedPostsRequest,
 *   !proto.social.post.PostListResponse>}
 */
const methodDescriptor_PostService_GetSavedPosts = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetSavedPosts',
  grpc.web.MethodType.UNARY,
  proto.social.post.GetSavedPostsRequest,
  proto.social.post.PostListResponse,
  /**
   * @param {!proto.social.post.GetSavedPostsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.PostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.post.GetSavedPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.PostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.PostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getSavedPosts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetSavedPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_GetSavedPosts,
      callback);
};


/**
 * @param {!proto.social.post.GetSavedPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.PostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getSavedPosts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetSavedPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_GetSavedPosts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.SavePostRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_SavePost = new grpc.web.MethodDescriptor(
  '/social.post.PostService/SavePost',
  grpc.web.MethodType.UNARY,
  proto.social.post.SavePostRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.SavePostRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.SavePostRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.savePost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/SavePost',
      request,
      metadata || {},
      methodDescriptor_PostService_SavePost,
      callback);
};


/**
 * @param {!proto.social.post.SavePostRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.savePost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/SavePost',
      request,
      metadata || {},
      methodDescriptor_PostService_SavePost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.SavePostRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_UnSavePost = new grpc.web.MethodDescriptor(
  '/social.post.PostService/UnSavePost',
  grpc.web.MethodType.UNARY,
  proto.social.post.SavePostRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.SavePostRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.SavePostRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.unSavePost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/UnSavePost',
      request,
      metadata || {},
      methodDescriptor_PostService_UnSavePost,
      callback);
};


/**
 * @param {!proto.social.post.SavePostRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.unSavePost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/UnSavePost',
      request,
      metadata || {},
      methodDescriptor_PostService_UnSavePost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.post.PostListResponse>}
 */
const methodDescriptor_PostService_GetArchivedPosts = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetArchivedPosts',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.post.PostListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.PostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.PostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.PostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getArchivedPosts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetArchivedPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_GetArchivedPosts,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.PostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getArchivedPosts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetArchivedPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_GetArchivedPosts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.Post,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_ArchivePost = new grpc.web.MethodDescriptor(
  '/social.post.PostService/ArchivePost',
  grpc.web.MethodType.UNARY,
  proto.social.post.Post,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.Post} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.archivePost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/ArchivePost',
      request,
      metadata || {},
      methodDescriptor_PostService_ArchivePost,
      callback);
};


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.archivePost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/ArchivePost',
      request,
      metadata || {},
      methodDescriptor_PostService_ArchivePost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.Post,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_UnArchivedPost = new grpc.web.MethodDescriptor(
  '/social.post.PostService/UnArchivedPost',
  grpc.web.MethodType.UNARY,
  proto.social.post.Post,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.Post} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.unArchivedPost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/UnArchivedPost',
      request,
      metadata || {},
      methodDescriptor_PostService_UnArchivedPost,
      callback);
};


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.unArchivedPost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/UnArchivedPost',
      request,
      metadata || {},
      methodDescriptor_PostService_UnArchivedPost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.common.CatListResponse>}
 */
const methodDescriptor_PostService_GetPostsCats = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetPostsCats',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  services_common_common_pb.CatListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.CatListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.CatListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.CatListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getPostsCats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetPostsCats',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPostsCats,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.CatListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getPostsCats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetPostsCats',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPostsCats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Category,
 *   !proto.social.common.Category>}
 */
const methodDescriptor_PostService_CreateSaveCat = new grpc.web.MethodDescriptor(
  '/social.post.PostService/CreateSaveCat',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Category,
  services_common_common_pb.Category,
  /**
   * @param {!proto.social.common.Category} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Category.deserializeBinary
);


/**
 * @param {!proto.social.common.Category} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Category)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Category>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.createSaveCat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/CreateSaveCat',
      request,
      metadata || {},
      methodDescriptor_PostService_CreateSaveCat,
      callback);
};


/**
 * @param {!proto.social.common.Category} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Category>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.createSaveCat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/CreateSaveCat',
      request,
      metadata || {},
      methodDescriptor_PostService_CreateSaveCat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Category,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_DeleteSaveCat = new grpc.web.MethodDescriptor(
  '/social.post.PostService/DeleteSaveCat',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Category,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.common.Category} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.common.Category} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.deleteSaveCat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/DeleteSaveCat',
      request,
      metadata || {},
      methodDescriptor_PostService_DeleteSaveCat,
      callback);
};


/**
 * @param {!proto.social.common.Category} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.deleteSaveCat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/DeleteSaveCat',
      request,
      metadata || {},
      methodDescriptor_PostService_DeleteSaveCat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.GetPostsByLocationRequest,
 *   !proto.social.post.PostListResponse>}
 */
const methodDescriptor_PostService_GetPostsByLocation = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetPostsByLocation',
  grpc.web.MethodType.UNARY,
  proto.social.post.GetPostsByLocationRequest,
  proto.social.post.PostListResponse,
  /**
   * @param {!proto.social.post.GetPostsByLocationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.PostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.post.GetPostsByLocationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.PostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.PostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getPostsByLocation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetPostsByLocation',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPostsByLocation,
      callback);
};


/**
 * @param {!proto.social.post.GetPostsByLocationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.PostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getPostsByLocation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetPostsByLocation',
      request,
      metadata || {},
      methodDescriptor_PostService_GetPostsByLocation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.LikeRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_Like = new grpc.web.MethodDescriptor(
  '/social.post.PostService/Like',
  grpc.web.MethodType.UNARY,
  proto.social.post.LikeRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.LikeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.LikeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.like =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/Like',
      request,
      metadata || {},
      methodDescriptor_PostService_Like,
      callback);
};


/**
 * @param {!proto.social.post.LikeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.like =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/Like',
      request,
      metadata || {},
      methodDescriptor_PostService_Like);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.GetProductPostsRequest,
 *   !proto.social.post.PostListResponse>}
 */
const methodDescriptor_PostService_GetProductPosts = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetProductPosts',
  grpc.web.MethodType.UNARY,
  proto.social.post.GetProductPostsRequest,
  proto.social.post.PostListResponse,
  /**
   * @param {!proto.social.post.GetProductPostsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.PostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.post.GetProductPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.PostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.PostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getProductPosts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetProductPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_GetProductPosts,
      callback);
};


/**
 * @param {!proto.social.post.GetProductPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.PostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getProductPosts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetProductPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_GetProductPosts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.GetProductPostsRequest,
 *   !proto.social.post.PostListResponse>}
 */
const methodDescriptor_PostService_GetProductPostsFeed = new grpc.web.MethodDescriptor(
  '/social.post.PostService/GetProductPostsFeed',
  grpc.web.MethodType.UNARY,
  proto.social.post.GetProductPostsRequest,
  proto.social.post.PostListResponse,
  /**
   * @param {!proto.social.post.GetProductPostsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.PostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.post.GetProductPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.PostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.PostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.getProductPostsFeed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/GetProductPostsFeed',
      request,
      metadata || {},
      methodDescriptor_PostService_GetProductPostsFeed,
      callback);
};


/**
 * @param {!proto.social.post.GetProductPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.PostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.getProductPostsFeed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/GetProductPostsFeed',
      request,
      metadata || {},
      methodDescriptor_PostService_GetProductPostsFeed);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.TogglePost,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_AdminPostArchive = new grpc.web.MethodDescriptor(
  '/social.post.PostService/AdminPostArchive',
  grpc.web.MethodType.UNARY,
  proto.social.post.TogglePost,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.TogglePost} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.TogglePost} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.adminPostArchive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/AdminPostArchive',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostArchive,
      callback);
};


/**
 * @param {!proto.social.post.TogglePost} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.adminPostArchive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/AdminPostArchive',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostArchive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.TogglePost,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_AdminPostDelete = new grpc.web.MethodDescriptor(
  '/social.post.PostService/AdminPostDelete',
  grpc.web.MethodType.UNARY,
  proto.social.post.TogglePost,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.TogglePost} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.TogglePost} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.adminPostDelete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/AdminPostDelete',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostDelete,
      callback);
};


/**
 * @param {!proto.social.post.TogglePost} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.adminPostDelete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/AdminPostDelete',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostDelete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.Post,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_AdminPostUpdate = new grpc.web.MethodDescriptor(
  '/social.post.PostService/AdminPostUpdate',
  grpc.web.MethodType.UNARY,
  proto.social.post.Post,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.Post} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.adminPostUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/AdminPostUpdate',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostUpdate,
      callback);
};


/**
 * @param {!proto.social.post.Post} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.adminPostUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/AdminPostUpdate',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.AdminGetPostsRequest,
 *   !proto.social.post.AdminPostListResponse>}
 */
const methodDescriptor_PostService_AdminGetPosts = new grpc.web.MethodDescriptor(
  '/social.post.PostService/AdminGetPosts',
  grpc.web.MethodType.UNARY,
  proto.social.post.AdminGetPostsRequest,
  proto.social.post.AdminPostListResponse,
  /**
   * @param {!proto.social.post.AdminGetPostsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.post.AdminPostListResponse.deserializeBinary
);


/**
 * @param {!proto.social.post.AdminGetPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.post.AdminPostListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.post.AdminPostListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.adminGetPosts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/AdminGetPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminGetPosts,
      callback);
};


/**
 * @param {!proto.social.post.AdminGetPostsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.post.AdminPostListResponse>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.adminGetPosts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/AdminGetPosts',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminGetPosts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.AdminPostActionRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_PostService_AdminPostAction = new grpc.web.MethodDescriptor(
  '/social.post.PostService/AdminPostAction',
  grpc.web.MethodType.UNARY,
  proto.social.post.AdminPostActionRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.post.AdminPostActionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.post.AdminPostActionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.adminPostAction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/AdminPostAction',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostAction,
      callback);
};


/**
 * @param {!proto.social.post.AdminPostActionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.adminPostAction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/AdminPostAction',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostAction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.post.AdminPostReportRequest,
 *   !proto.social.common.ReportResponseList>}
 */
const methodDescriptor_PostService_AdminPostReport = new grpc.web.MethodDescriptor(
  '/social.post.PostService/AdminPostReport',
  grpc.web.MethodType.UNARY,
  proto.social.post.AdminPostReportRequest,
  services_common_common_pb.ReportResponseList,
  /**
   * @param {!proto.social.post.AdminPostReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.ReportResponseList.deserializeBinary
);


/**
 * @param {!proto.social.post.AdminPostReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.ReportResponseList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.ReportResponseList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.post.PostServiceClient.prototype.adminPostReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.post.PostService/AdminPostReport',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostReport,
      callback);
};


/**
 * @param {!proto.social.post.AdminPostReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.ReportResponseList>}
 *     Promise that resolves to the response
 */
proto.social.post.PostServicePromiseClient.prototype.adminPostReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.post.PostService/AdminPostReport',
      request,
      metadata || {},
      methodDescriptor_PostService_AdminPostReport);
};


module.exports = proto.social.post;

